__turbopack_context__.v({
  "container": "EmailIcon-module__E_6o3G__container",
});
